module.exports = __webpack_public_path__ + "img/ae79e5d4-bb76-4724-8a03-4b9403682939.0e87633d.png";